import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { memo } from 'react'
import { FieldArray } from 'react-final-form-arrays'

import useStyles from '../styles'
import ScansRow from './ScansRow'

const BarcodeScans = () => {
  const classes = useStyles()

  return (
    <>
      <Table className={classes.table}>
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.headerRow}>
            <TableCell className={classes.headerCell}>Date</TableCell>
            <TableCell className={classes.headerCell}>Tracking ID</TableCell>
            <TableCell className={classes.headerCell}>Type</TableCell>
            <TableCell className={classes.headerCell}>Hub</TableCell>
            <TableCell className={classes.headerCell}>Source</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <FieldArray name="scans">
            {({ fields }) =>
              fields.map(fieldName => <ScansRow fieldName={fieldName} key={fieldName} />)
            }
          </FieldArray>
        </TableBody>
      </Table>
    </>
  )
}

export default memo(BarcodeScans)
